import React, { useEffect, useState } from "react";
import Layout from "../../components/admin/Layout";
import Helmet from "react-helmet";
import apiRequest from "../../utils/admin/apiRequest";
import { useSelector } from "react-redux";

const ServerInfo = () => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    apiRequest.getServerInfo().then((res) => {
      setInfo(res?.data?.data?.info);
    });
  }, []);

  const renderNetworkInterfaces = (interfaces) => {
    return Object.entries(interfaces || {}).map(([key, value]) => (
      <div key={key}>
        <strong>{key}:</strong> {value.length ? value.join(", ") : "N/A"}
      </div>
    ));
  };
  const BRAND_NAME = useSelector(
    (state) => state.globalState?.siteSetting?.site_settings?.site_name
  );
  return (
    
    <Layout>
      <Helmet>
        <title>Server Info - {BRAND_NAME ?? ''}</title>
      </Helmet>
      <div className="p-6 mx-auto space-y-6">
        <h1 className="text-2xl font-semibold text-gray-800">
          Server Information
        </h1>
        {!info ? (
          <p className="text-gray-500">Loading...</p>
        ) : (
          <>
            {/* System Info */}
            <div className="p-5 bg-white shadow rounded-2xl">
              <h2 className="mb-4 text-lg font-bold">System Info</h2>
              <div className="grid grid-cols-2 gap-4 text-sm text-gray-700 md:grid-cols-3">
                <div>
                  <strong>Hostname:</strong> {info.hostname}
                </div>
                <div>
                  <strong>Platform:</strong> {info.platform}
                </div>
                <div>
                  <strong>OS Type:</strong> {info.osType}
                </div>
                <div>
                  <strong>OS Release:</strong> {info.osRelease}
                </div>
                <div>
                  <strong>Architecture:</strong> {info.architecture}
                </div>
                <div>
                  <strong>Uptime:</strong> {info.uptime}
                </div>
                <div>
                  <strong>Boot Time:</strong>{" "}
                  {new Date(info.bootTime).toLocaleString()}
                </div>
                <div>
                  <strong>Current User:</strong> {info.currentUser}
                </div>
                <div>
                  <strong>Node Version:</strong> {info.nodeVersion}
                </div>
              </div>
            </div>

            {/* Memory Usage */}
            <div className="p-5 bg-white shadow rounded-2xl">
              <h2 className="mb-4 text-lg font-bold">Memory Info</h2>
              <div className="grid grid-cols-2 gap-4 text-sm text-gray-700">
                <div>
                  <strong>Total Memory:</strong> {info.totalMemory}
                </div>
                <div>
                  <strong>Free Memory:</strong> {info.freeMemory}
                </div>
                <div>
                  <strong>Heap Total:</strong> {info.memoryUsage.heapTotal}
                </div>
                <div>
                  <strong>Heap Used:</strong> {info.memoryUsage.heapUsed}
                </div>
                <div>
                  <strong>RSS:</strong> {info.memoryUsage.rss}
                </div>
                <div>
                  <strong>External:</strong> {info.memoryUsage.external}
                </div>
              </div>
            </div>

            {/* CPU Info */}
            <div className="p-5 bg-white shadow rounded-2xl">
              <h2 className="mb-4 text-lg font-bold">CPU Info</h2>
              <div className="grid grid-cols-2 gap-4 text-sm text-gray-700">
                <div>
                  <strong>CPU Cores:</strong> {info.cpuCores}
                </div>
                <div>
                  <strong>CPU Model:</strong> {info.cpuModel}
                </div>
              </div>
            </div>

            {/* Network Interfaces */}
            <div className="p-5 bg-white shadow rounded-2xl">
              <h2 className="mb-4 text-lg font-bold">Network Interfaces</h2>
              <div className="space-y-2 text-sm text-gray-700">
                {renderNetworkInterfaces(info.networkInterfaces)}
              </div>
            </div>

            {/* Process & Paths */}
            <div className="p-5 bg-white shadow rounded-2xl">
              <h2 className="mb-4 text-lg font-bold">Process Info</h2>
              <div className="grid grid-cols-1 gap-4 text-sm text-gray-700 md:grid-cols-2">
                <div>
                  <strong>Process ID:</strong> {info.processId}
                </div>
                <div>
                  <strong>Working Directory:</strong> {info.workingDirectory}
                </div>
                <div>
                  <strong>Home Directory:</strong> {info.homeDir}
                </div>
                <div>
                  <strong>Temp Directory:</strong> {info.tempDir}
                </div>
                <div className="md:col-span-2">
                  <strong>Exec Args:</strong> {info.execArgs?.join(" ")}
                </div>
              </div>
            </div>

            {/* Handles & Requests */}
            <div className="p-5 bg-white shadow rounded-2xl">
              <h2 className="mb-4 text-lg font-bold">System Load</h2>
              <div className="grid grid-cols-2 gap-4 text-sm text-gray-700">
                <div>
                  <strong>Active Handles:</strong> {info.activeHandles}
                </div>
                <div>
                  <strong>Active Requests:</strong> {info.activeRequests}
                </div>
                <div>
                  <strong>Load Average:</strong> {info.loadAverage?.join(", ")}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </Layout>
  );
};

export default ServerInfo;
